import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    actionIcon: {
      cursor: 'pointer',
    },
  };
});
